import ivclass from '@invideoio/web-shared/Modules/IVClass';
import React from 'react';
import Stars from '@components/stars';

interface TestimonySourceRatingProps {
  name: string;
  source?: string;
  ratings?: number;
  testimonySourceRatingClass?: string;
}

const TestimonySourceRating = (props: TestimonySourceRatingProps) => {
  const { name, source, ratings, testimonySourceRatingClass } = props;
  return (
    <div className={ivclass('iv-mt-10')}>
      <div
        className={ivclass(
          'iv-flex',
          'iv-justify-between',
          'iv-items-end',
          'iv-h-[38px]',
          testimonySourceRatingClass,
        )}
      >
        <span
          className={ivclass(
            'iv-text-grey-85',
            'xl:iv-text-body-3xl iv-text-body-2xl sm:iv-text-body-m',
            'xl:iv-m-body-3xl iv-m-body-2xl sm:iv-m-body-m',
            'iv-font-medium',
          )}
        >
          {name}
        </span>
        <div className={ivclass('iv-flex', 'iv-flex-col', 'iv-items-center')}>
          <span
            className={ivclass(
              'xl:iv-mb-8 iv-mb-10',
              'iv-text-grey-55',
              'xl:iv-text-body-xs iv-text-body-2xs',
              'xl:iv-m-body-xs iv-m-body-2xs',
              'iv-font-medium',
              'iv-overflow-ellipsis iv-overflow-hidden',
            )}
          >
            {source}
          </span>
          <span
            className={ivclass('xl:iv-w-[100px] iv-w-[90px] lg:iv-mb-[-3px]')}
          >
            {ratings && (
              <Stars
                count={ratings}
                color="--deep-blue"
                maskColor="--testimonial-star-mask"
                ratingClassName="iv-testimonials-ratings"
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestimonySourceRating;
